export interface ApiResponse extends ServicesResponse{
  data: any;
}

export interface ServicesResponse {
  status: ServicesResponseStatus
}

export interface ServicesResponseStatus {
  codice: string,
  descrizione: string,
  esito: string
}

export interface LoginResponse extends ApiResponse {
  data: AuthenticationResponse;
}

export interface AuthenticationResponse {
  dd_notify: string;
  id_token: string;
  is_locked: string;
  psw_exp_date: string;
  username: string;
}
